<template>
    <div style="background-color:rgb(204 204 204 / 0.25);;padding:20px">
        <div style="display:flex;justify-content: center;padding-bottom:30px">
            <h3>Business Owner Information</h3>
        </div>
        
        <a-form-model
                ref="AddBusinesInfoform"
                :model="businessInfoform"
                :rules="rules"  
            >
                <a-row type="flex" justify="space-around">
                    <a-col :span="8">
                        <a-form-model-item label="First Name" ref="ownerFirstName" prop="ownerFirstName">
                            <a-input 
                                v-model="businessInfoform.ownerFirstName"
                            />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="Last Name" ref="ownerLastName" prop="ownerLastName">
                            <a-input 
                                v-model="businessInfoform.ownerLastName"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="8">
                        <a-form-model-item label="Enter Age" ref="age" prop="age">
                            <a-input 
                                v-model="businessInfoform.age"
                            />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="Gender" ref="gender" prop="gender">
                            <a-select v-model="businessInfoform.gender" placeholder="Your gender">
                                    <a-select-option value="male">
                                        Male
                                    </a-select-option>
                                    <a-select-option value="female">
                                        Female
                                    </a-select-option>
                                </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="8">
                        <a-form-model-item label="Phone Number" ref="ownerMobile" prop="ownerMobile">
                            <a-input 
                                v-model="businessInfoform.ownerMobile"
                            />
                        </a-form-model-item>
                    </a-col>
                     <a-col :span="8">
                        <a-form-model-item label="Years in Business" ref="yearsInBusiness" prop="yearsInBusiness">
                             <a-input 
                                v-model="businessInfoform.yearsInBusiness"
                            />
                        </a-form-model-item>
                    </a-col>
                   
                </a-row>
                
                <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
                </div>
          
            <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:50px;">
                <a-button @click="handleSubmit"  style="background: #418a49;height:45px;color:#fff;width:256px;">
                    Save & Continue
                </a-button>
            </a-form-model-item>
            </a-form-model>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

    export default {
        name: "BusinessInfo",
        data(){
            return{
                businessInfoform:{
                    ownerFirstName:'',
                    ownerLastName:'',
                    age:'',
                    gender:'',
                    ownerMobile:'',
                    educationLevel:'',
                    numberOfStores:'',
                    yearsInBusiness:''
                },
                year:'year',
                dateFormat: 'YYYY',
                loading:false,
                IsOpen: false,
                rules: {
                    ownerFirstName: [
                        { required: true, message: 'Please enter your first name' , trigger: 'change'},
                    ],
                    ownerLastName: [
                        { required: true, message: 'Please enter your first name' , trigger: 'change'},
                    ],
                    gender: [
                        { required: true, message: 'Please enter your gender' , trigger: 'change'},
                    ],
                    numberOfStores: [
                        { required: true, message: 'Please enter your number of stores owned' , trigger: 'change'},
                    ],
                    ownerMobile: [
                        { required: true, message: 'Please enter your phone number' , trigger: 'change'},
                    ],
                   
                    educationLevel: [
                        { required: true, message: 'Please choose your education level' , trigger: 'change'},
                    ],
                    age: [
                        { required: true, message: 'Please enter your age', trigger: 'change' },
                        {   
                            pattern: new RegExp(/^[1-9]\d*$/), 
                            message: 'Please enter valid number', 
                            trigger: 'change'
                        },
                    ],
                     yearsInBusiness: [
                        { required: true, message: 'Please enter your years in business' , trigger: 'change'},
                        // { min: 4, message: 'Please years should be 4 digits' , trigger: 'change'},
                        // { max: 4, message: 'Please years should be 4 digits' , trigger: 'change'},
                        {   
                            pattern: new RegExp(/^[1-9]\d*$/), 
                            message: 'Please enter valid number', 
                            trigger: 'change'
                        },
                    ],
                },
            }
        },
        computed: mapGetters(['getBusinessInfo']),
        methods:{
            ...mapActions(['setStepCount','setBusinessInfo','setPercentageBar']),
            handleSubmit(){
                this.$refs.AddBusinesInfoform.validate(valid => {
                    if (valid) {
                        // console.log("businessInfoform | ", this.businessInfoform)
                        // this.setPercentageBar(25);
                        
                        this.setStepCount(2)
                        this.$router.push(`/company-info`).catch(()=>{});
                    }else {
                        return false;
                    }
                })
            },
            onPanelChange(value) {
                this.IsOpen = false
                // console.log("yearsInBusiness | ", String(moment(value).year()))
                this.businessInfoform.yearsInBusiness = moment(value)
            },
            onOpenChange(status){
                if(status){
                    this.IsOpen = true
                } else {
                    this.IsOpen = true
                }
            },
            moment
        },
        created(){
            // console.log("getBusinessInfo | ", this.getBusinessInfo)
            if(this.getBusinessInfo){
                this.businessInfoform = {
                    ownerFirstName:this.getBusinessInfo.ownerFirstName,
                    ownerLastName:this.getBusinessInfo.ownerLastName,
                    age:this.getBusinessInfo.age,
                    gender:this.getBusinessInfo.gender,
                    ownerMobile:this.getBusinessInfo.ownerMobile,
                    educationLevel:this.getBusinessInfo.educationLevel,
                    fieldOfTraining:this.getBusinessInfo.fieldOfTraining,
                    numberOfStores:this.getBusinessInfo.numberOfStores,
                    yearsInBusiness:this.getBusinessInfo.yearsInBusiness
                }
            }
        }
    }
</script>

<style scoped>
.img_size{
    max-width: 56px;
    max-height: 55px;
}
</style>